<template>
    <div class="answer-item__con">
        <div class="answer-item__nickname">
            {{ commenterName }}
        </div>
        <div class="answer-item__content">
            {{ comment.content }}
        </div>
        <div class="answer-item__info">
            <div>
                <div class="text-center" style="white-space:none">{{ comment?.createdAt?.toDateTime() }}</div>
                <div v-show="isCommenter">
                    <span class="answer-item__info-col"><response-comment-modify v-model="value" :comment="comment"/></span>
                    <span class="answer-item__info-col"><v-btn text @click="remove">삭제</v-btn></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
import { USER_TYPES } from "@/assets/data/CONSTANTS";
import ResponseCommentModify from "./response-comment-modify.vue";
export default {
    components: { ResponseCommentModify },
    props: ["value", "comment"],
    computed: {
        commenterName() {
            const commenter = this.comment?.commenter || {};
            if (commenter.type == USER_TYPES.INDIVIDUAL) return commenter.nickname;
            if (commenter.type == USER_TYPES.ORGANIZATION) return commenter.companyName;
            return "";
        },
        isCommenter() {
            return this.comment._commenter == this.$store.state.payload._user;
        },
    },
    methods: {
        async remove() {
            try {
                const go = confirm("답글을 삭제하시겠습니까?");
                if (go) {
                    const { counselComment } = await api.v1.counsels.comments.delete({ _id: this.comment._id });

                    const responses = [...this.value.responses];

                    const response = responses.find(({ _id }) => _id == counselComment._response);
                    response._comments = (response._comments || []).filter((_comment) => _comment !== counselComment._id);
                    response.comments = (response.comments || []).filter(({ _id }) => _id !== counselComment._id);

                    this.$emit("input", { ...this.value, responses });

                    alert("삭제되었습니다.");
                }
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
};
</script>

<style></style>
